<template>
    <div class="mt-6 animate-pulse">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div class="space-y-5">
                <div v-for="n in 6" :key="'left-' + n" class="space-y-2">
                    <div class="h-4 w-40 rounded bg-slate-200"></div>
                    <div class="h-8 w-full rounded bg-slate-100"></div>
                </div>
            </div>

            <div class="space-y-5">
                <div v-for="n in 4" :key="'right-' + n" class="space-y-2">
                    <div class="h-4 w-40 rounded bg-slate-200"></div>
                    <div class="h-8 w-full rounded bg-slate-100"></div>
                </div>
            </div>

            <div class="col-span-1 md:col-span-2 space-y-3">
                <div class="h-4 w-48 rounded bg-slate-200"></div>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
                    <div v-for="n in 3" :key="'collab-' + n" class="h-16 w-full rounded bg-slate-100"></div>
                </div>
            </div>

            <div class="col-span-1 md:col-span-2 space-y-3">
                <div class="h-4 w-48 rounded bg-slate-200"></div>
                <div class="grid grid-cols-2 gap-3 md:grid-cols-4">
                    <div v-for="n in 4" :key="'platform-' + n" class="h-16 w-full rounded bg-slate-100"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonCreatorProfileBackground',
}
</script>
